<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="isVisible"
    class="full-screen-creative-thumbnail"
    @click="close">
    <div>
      <div class="pane-header">
        <span class="icon"><icon-colored-image /></span>
        <span class="text">{{ name }}</span>
        <div class="actions">
          <button
            class="btn btn-sm btn-default"
            @click="close">
            <span>&times;</span>
          </button>
        </div>
      </div>
      <div class="pane-content">
        <video
          v-if="isVideoURL"
          class="video-content"
          controls>
          <source :src="imageUrl" />
        </video>
        <img
          v-else
          :src="imageUrl" />
        <div class="pane-footer">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { IconColoredImage } from '@/common/icons/colored';

  const emits = defineEmits(['close']);
  const props = withDefaults(
    defineProps<{
      isVisible?: boolean;
      name: string;
      imageUrl: string;
    }>(),
    {
      isVisible: false,
    },
  );

  const isVideoURL = computed(() => props.imageUrl.endsWith('.mp4'));

  function close(): void {
    emits('close');
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;
  #app {
    .full-screen-creative-thumbnail {
      background: rgba(0, 0, 0, 0.33);
      display: flex;
      align-items: center;
      align-content: center;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 10000;

      .video-content {
        max-width: 80vw;
        max-height: 80vh;
      }

      > div {
        box-shadow: var(--panesShadow);

        margin: auto;
        position: relative;
        max-width: 90%;

        .pane-header {
          box-shadow: none;
        }
        .pane-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fff;
          background-origin: content-box;
          box-shadow: none;
          margin-bottom: 0;
        }

        img {
          border: 0.1rem solid #ccc;
          max-width: 100%;
          max-height: 80vh;
        }
      }
    }
  }
</style>
